import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const CancelOrderTableRowItem_itemFragment = graphql(`
  fragment CancelOrderTableRowItem_item on Item {
    name
    imageUrl
    tokenId
  }
`)

export const CancelOrderTableRowItem_orderFragment = graphql(
  `
    fragment CancelOrderTableRowItem_order on Order {
      collection {
        name
        imageUrl
        ...CollectionLockup
      }
      item {
        ...CancelOrderTableRowItem_item
        imageUrl
        name
        tokenId
      }
      side
      type
      traitIdentifier {
        traitType
        value
      }
      traitIdentifiers {
        traitType
        value
      }
    }
  `,
  [CancelOrderTableRowItem_itemFragment, CollectionLockupFragment],
)
